import { ThreadReadStatus } from '@weave/schema-gen-ts/dist/schemas/sms/data/v4/sms_service.pb';
import { Direction, Status } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { SMS } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';

const getMessageType = ({
  status,
  direction,
  autogeneratedBy,
}: Pick<SMS, 'status' | 'direction' | 'autogeneratedBy'>):
  | 'manual-outbound'
  | 'automated-outbound'
  | 'error'
  | 'inbound' => {
  if (status === Status.STATUS_ERROR) return 'error';

  if (direction === Direction.DIRECTION_OUTBOUND && autogeneratedBy) {
    return 'automated-outbound';
  } else if (direction === Direction.DIRECTION_OUTBOUND) {
    return 'manual-outbound';
  }

  return 'inbound';
};

export const convertSMSStatusToPossibleThreadReadStatus = ({
  status,
  direction,
  autogeneratedBy,
}: Pick<SMS, 'status' | 'direction' | 'autogeneratedBy'>): (ThreadReadStatus | 'previous')[] => {
  const messageType = getMessageType({ status, direction, autogeneratedBy });

  /*
   * READ
   * - Manual outbound messages ALWAYS
   * - Automated outbound messages have no effect (use previous ThreadReadStatus)
   *
   * NEW
   * - Manual inbound messages ALWAYS (until marked as read)
   *
   * ERROR
   * - Any outbound message that has an error
   *
   * REPLIED
   * - Manual outbound messages ALWAYS
   * - Automated messages have no effect (use previuos ThreadReadStatus)
   *
   * UNREPLIED
   * - Manual inbound messages ALWAYS (until marked as replied)
   */
  switch (messageType) {
    case 'error':
      return [ThreadReadStatus.ERROR];
    case 'inbound':
      return [ThreadReadStatus.NEW, ThreadReadStatus.UNREPLIED];
    case 'manual-outbound':
      return [ThreadReadStatus.READ, ThreadReadStatus.REPLIED];
    case 'automated-outbound':
      return ['previous'];
  }
};
